// pt-BR translations for GetPaid's self-onboarding flow. Full parity with
// onboarding.en.ts — native, consumer-grade Portuguese; no crypto wording.
const onboarding: Record<string, string> = {
  // Cabeçalho da página
  'onboarding.title': 'Prepare-se para receber',
  'onboarding.description':
    'Poucos passos e você já pode receber do exterior — o dinheiro cai no seu Pix em reais.',
  'onboarding.loading': 'Carregando…',
  'onboarding.error.load': 'Não foi possível carregar seu status. Atualize para tentar de novo.',

  // Rótulos do stepper
  'onboarding.step.terms': 'Termos',
  'onboarding.step.identity': 'Identidade',
  'onboarding.step.bankAccount': 'Pix',
  'onboarding.step.status': 'Análise',

  // Passo 1 — termos do parceiro
  'onboarding.tos.title': 'Passo 1 — Aceite os termos',
  'onboarding.tos.subtitle':
    'Nosso parceiro de pagamentos regulado abre sua conta de recebimento. Leia e aceite os termos para continuar.',
  'onboarding.tos.accept': 'Ler e aceitar os termos',
  'onboarding.tos.opening': 'Abrindo…',
  'onboarding.tos.recorded': 'Termos aceitos.',

  // Passo 2 — identidade: empresa ou pessoa física
  'onboarding.entityType': 'Como você vai receber?',
  'onboarding.entityType.hint':
    'Escolha se você recebe como empresa (pessoa jurídica) ou como pessoa física (você mesmo).',
  'onboarding.entityType.business': 'Como empresa',
  'onboarding.entityType.individual': 'Como pessoa física',

  // Passo 2 — empresa (KYB)
  'onboarding.kyb.title': 'Passo 2 — Verifique sua empresa',
  'onboarding.kyb.subtitle':
    'Precisamos confirmar sua empresa para que ela receba em reais via Pix. Todos os campos e documentos são obrigatórios.',
  'onboarding.kyb.submit': 'Enviar para análise',
  'onboarding.kyb.submitting': 'Enviando…',
  'onboarding.kyb.submitted': 'Enviado para análise. Avisaremos por e-mail assim que for aprovado.',

  // Passo 2 — pessoa física (KYC)
  'onboarding.kyc.title': 'Passo 2 — Verifique sua identidade',
  'onboarding.kyc.subtitle':
    'Precisamos confirmar quem você é para que você receba em reais via Pix. Todos os campos e documentos são obrigatórios.',
  'onboarding.kyc.resubmit.subtitle':
    'Preencha seus dados de novo, reenvie seus documentos e envie mais uma vez.',

  // Seções e campos do formulário de empresa
  'onboarding.kyb.section.business': 'Dados da empresa',
  'onboarding.kyb.section.address': 'Endereço da empresa',
  'onboarding.kyb.section.docs': 'Documentos da empresa',
  'onboarding.kyb.section.owners': 'Sócios',
  'onboarding.kyb.legalName': 'Razão social',
  'onboarding.kyb.cnpj': 'CNPJ',
  'onboarding.kyb.taxId': 'CNPJ / Tax ID',
  'onboarding.kyb.cnpjHint': '14 dígitos — a pontuação é removida automaticamente.',
  'onboarding.kyb.cnpjInvalid': 'O CNPJ deve ter 14 dígitos.',
  'onboarding.kyb.taxIdLocked':
    'O CNPJ não pode ser alterado após a verificação. Fale com o suporte se sua empresa mudou.',
  'onboarding.kyb.formationDate': 'Data de abertura',
  'onboarding.kyb.email': 'E-mail da empresa',
  'onboarding.kyb.website': 'Site',
  'onboarding.kyb.addressLine1': 'Endereço (linha 1)',
  'onboarding.kyb.addressLine2': 'Endereço (linha 2) (opcional)',
  'onboarding.kyb.city': 'Cidade',
  'onboarding.kyb.state': 'Estado / região',
  'onboarding.kyb.postal': 'CEP',
  'onboarding.kyb.country': 'País',
  'onboarding.kyb.doc.incorporation': 'Contrato social',
  'onboarding.kyb.doc.ownership': 'Comprovante de titularidade',
  'onboarding.kyb.poaType': 'Comprovante de endereço — tipo',
  'onboarding.kyb.doc.poa': 'Comprovante de endereço — arquivo',

  // Campos dos sócios
  'onboarding.kyb.addOwner': 'Adicionar sócio',
  'onboarding.kyb.removeOwner': 'Remover',
  'onboarding.kyb.owner': 'Sócio {n}',
  'onboarding.kyb.owner.role': 'Função',
  'onboarding.kyb.owner.firstName': 'Nome',
  'onboarding.kyb.owner.lastName': 'Sobrenome',
  'onboarding.kyb.owner.dob': 'Data de nascimento',
  'onboarding.kyb.owner.taxId': 'CPF',
  'onboarding.kyb.owner.addr1': 'Endereço (linha 1)',
  'onboarding.kyb.owner.city': 'Cidade',
  'onboarding.kyb.owner.state': 'Estado / região',
  'onboarding.kyb.owner.postal': 'CEP',
  'onboarding.kyb.owner.country': 'País',
  'onboarding.kyb.owner.idDocType': 'Tipo de documento',
  'onboarding.kyb.owner.idDocCountry': 'País do documento',
  'onboarding.kyb.owner.selfie': 'Selfie',
  'onboarding.kyb.owner.idFront': 'Documento — frente',
  'onboarding.kyb.owner.poaType': 'Comprovante de endereço — tipo',
  'onboarding.kyb.owner.poa': 'Comprovante de endereço — arquivo',

  // Funções e rótulos de opções
  'onboarding.role.beneficialOwner': 'Beneficiário final',
  'onboarding.role.beneficialControlling': 'Beneficiário final + controlador',
  'onboarding.role.controllingPerson': 'Pessoa controladora',
  'onboarding.idDoc.passport': 'Passaporte',
  'onboarding.idDoc.idCard': 'RG / documento de identidade',
  'onboarding.idDoc.drivers': 'CNH',
  'onboarding.poa.utilityBill': 'Conta de consumo',
  'onboarding.poa.bankStatement': 'Extrato bancário',
  'onboarding.poa.rentalAgreement': 'Contrato de aluguel',
  'onboarding.poa.taxDocument': 'Documento fiscal',
  'onboarding.poa.governmentCorrespondence': 'Correspondência de órgão público',

  // Campos do formulário de pessoa física (KYC)
  'onboarding.kyc.section.personal': 'Dados pessoais',
  'onboarding.kyc.section.address': 'Endereço',
  'onboarding.kyc.section.docs': 'Documentos de identidade',
  'onboarding.kyc.firstName': 'Nome',
  'onboarding.kyc.lastName': 'Sobrenome',
  'onboarding.kyc.dob': 'Data de nascimento',
  'onboarding.kyc.taxId': 'CPF',
  'onboarding.kyc.taxId.generic': 'Tax ID',
  'onboarding.kyc.email': 'E-mail',
  'onboarding.kyc.addressLine1': 'Endereço (linha 1)',
  'onboarding.kyc.addressLine2': 'Endereço (linha 2) (opcional)',
  'onboarding.kyc.city': 'Cidade',
  'onboarding.kyc.state': 'Estado / região',
  'onboarding.kyc.postal': 'CEP',
  'onboarding.kyc.country': 'País',
  'onboarding.kyc.idDocType': 'Tipo de documento',
  'onboarding.kyc.idDocCountry': 'País do documento',
  'onboarding.kyc.selfie': 'Selfie',
  'onboarding.kyc.idFront': 'Documento — frente',
  'onboarding.kyc.poaType': 'Comprovante de endereço — tipo',
  'onboarding.kyc.poa': 'Comprovante de endereço — arquivo',
  'onboarding.kyc.missingDocs':
    'Envie sua selfie, documento de identidade e comprovante de endereço antes de enviar.',

  // Estados de upload e validação
  'onboarding.upload.uploading': 'Enviando…',
  'onboarding.upload.uploaded': 'Enviado ✓',
  'onboarding.kyb.docsOptionalHint':
    'Opcional — envie apenas para substituir o documento já registrado.',
  'onboarding.kyb.missingDocs':
    'Envie todos os documentos obrigatórios (empresa e cada sócio) antes de enviar.',
  'onboarding.kyb.ownersToggle': 'Também atualizar os sócios',
  'onboarding.kyb.ownersToggleHint':
    'Os dados e documentos dos sócios devem ser reenviados por completo ao atualizá-los.',

  // Passo 3 — chave Pix
  'onboarding.bank.title': 'Passo 3 — Para onde enviamos seu dinheiro?',
  'onboarding.bank.subtitle':
    'Informe a chave Pix onde você quer receber. É para lá que cada pagamento vai, em reais.',
  'onboarding.bank.pixKey': 'Chave Pix',
  'onboarding.bank.pixKeyHint': 'CPF/CNPJ, telefone, e-mail ou chave Pix aleatória.',
  'onboarding.bank.save': 'Salvar chave Pix',
  'onboarding.bank.saving': 'Salvando…',
  'onboarding.bank.saved': 'Chave Pix salva.',
  'onboarding.bank.savedTitle': 'Chave Pix registrada',
  'onboarding.bank.savedBody': 'Seus recebimentos serão enviados para a chave Pix cadastrada.',
  'onboarding.bank.update': 'Atualizar chave Pix',
  'onboarding.bank.locked': 'Verifique sua identidade acima antes de adicionar sua chave Pix.',

  // Passo 4 — painel de status (em análise)
  'onboarding.status.pendingTitle': 'Análise em andamento',
  'onboarding.status.pendingBody':
    'Nosso parceiro está analisando seus dados. Costuma levar um pouco — avisaremos por e-mail assim que terminar. Você pode sair desta página.',

  // Painel de status (recusado)
  'onboarding.status.rejectedTitle': 'Não conseguimos verificar você',
  'onboarding.status.rejectedBody':
    'Nosso parceiro não conseguiu verificar este envio. Confira os pontos abaixo, corrija seus dados e envie de novo.',
  'onboarding.kyb.resubmit.cta': 'Enviar de novo',
  'onboarding.kyb.resubmit.submitting': 'Enviando…',
  'onboarding.kyb.resubmit.title': 'Corrigir e enviar de novo',
  'onboarding.kyb.resubmit.subtitle':
    'Mantivemos seus dados anteriores. Corrija os pontos acima, reenvie seus documentos e envie de novo.',
  'onboarding.kyb.resubmit.done': 'Enviado — nosso parceiro está analisando novamente.',
  'onboarding.warnings.none':
    'Nenhum motivo específico foi informado. Confira seus dados e documentos e envie de novo.',
  'onboarding.warnings.compliance': 'Questões de conformidade',
  'onboarding.warnings.fraud': 'Verificações de fraude',
  'onboarding.warnings.issue': 'Problema',

  // Painel de status (aprovado) e edição
  'onboarding.approved.title': 'Você está verificado',
  'onboarding.approved.body':
    'Sua identidade está verificada. Adicione ou confirme sua chave Pix abaixo e pronto para receber.',
  'onboarding.edit.cta': 'Editar informações',
  'onboarding.edit.cancel': 'Cancelar edição',
  'onboarding.edit.title': 'Editar suas informações',
  'onboarding.edit.subtitle':
    'Atualize seus dados com nosso parceiro. Os documentos são opcionais — envie apenas o que quiser substituir. As mudanças passam por nova análise e podem aparecer como "em análise" até serem reaprovadas.',
  'onboarding.edit.note': 'Você pode continuar recebendo enquanto a análise acontece.',
  'onboarding.edit.submit': 'Enviar mudanças',
  'onboarding.edit.submitting': 'Enviando…',
  'onboarding.edit.done': 'Mudanças enviadas — nosso parceiro está analisando.',

  // Resumo somente leitura da verificação (KybReceiverPanel)
  'onboarding.detail.title': 'Resumo da verificação',
  'onboarding.detail.legalName': 'Razão social',
  'onboarding.detail.taxId': 'CNPJ',
  'onboarding.detail.formationDate': 'Data de abertura',
  'onboarding.detail.email': 'E-mail',
  'onboarding.detail.website': 'Site',
  'onboarding.detail.country': 'País',
  'onboarding.detail.address': 'Endereço',
  'onboarding.detail.limits.title': 'Limites',
  'onboarding.detail.limits.perTransaction': 'Por transação',
  'onboarding.detail.limits.daily': 'Diário',
  'onboarding.detail.limits.monthly': 'Mensal',
  'onboarding.detail.owners.title': 'Sócios',
  'onboarding.detail.owners.role': 'Função',
  'onboarding.detail.owners.name': 'Nome',
  'onboarding.detail.owners.dob': 'Data de nascimento',
  'onboarding.detail.owners.country': 'País',
  'onboarding.detail.owners.taxId': 'CPF',
  'onboarding.detail.status': 'Status',

  // Conclusão — CTA criar primeira cobrança
  'onboarding.done.title': 'Tudo pronto!',
  'onboarding.done.body':
    'Sua identidade está verificada e sua chave Pix está registrada. Crie sua primeira cobrança e comece a receber.',
  'onboarding.done.cta': 'Criar sua primeira cobrança',

  // Placeholders / auxiliares de campo
  'onboarding.select.placeholder': 'Selecione…',
};

export default onboarding;
